import React from 'react';
import {useParams} from 'react-router-dom';

import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

import {
  FeatureFlagEnum,
  ModuleEnum,
  PermissionOperationEnum,
} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import type {
  ItemDefinitionViewType} from 'src/app/item-tracker/ItemDefinitionForm';
import {
  ItemDefinitionForm
} from 'src/app/item-tracker/ItemDefinitionForm';
import {itemDefinitionDocumentTitle} from 'src/app/item-tracker/itemDefinitionHelpers';
import type {ViewModeType} from 'src/shared/services/RouterService/IRouteService';
import {ItemDefinitionRouteService} from 'src/shared/services/RouterService/ItemDefinitionRouteService';

import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';

const ItemDefinitionEditPage: React.FC = () => {
  useSetDocumentTitle(`${itemDefinitionDocumentTitle} - Edit`);

  const {id, view} = useParams();

  const mode: ViewModeType = 'edit';
  const router = new ItemDefinitionRouteService(false, mode, {
    view: view as ItemDefinitionViewType,
  });

  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.ItemTracker}>
      {id !== undefined && (
        <ItemDefinitionForm
          id={Number(id)}
          mode="edit"
          view={view as ItemDefinitionViewType}
          router={router}
        />
      )}
    </ContentWrapper>
  );
};

export default ItemDefinitionEditPage;

routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.ItemDefinitionEdit(':id', ':view'),
  element: <ItemDefinitionEditPage />,
  isPrivate: true,
  module: ModuleEnum.ItemTrackerDefinitions,
  operation: PermissionOperationEnum.Update,
});
